import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

// Services
import Person from 'services/data/person';

// Components
import { SelectInput } from 'components/forms/form-elements';


function UserSelect({ users, team, ...props }) {
  const options = _(users)
    .filter(user => {
      // If it is an active Praece user
      if (Person.isPraece(user)) return true;

      // If the user is currently selected
      if (user.id === props.input.value) return true;

      return false;
    })
    .filter(user => {
      // If no team is specified just return everyone
      if (!team) return true;
      if (user.team && user.team.id === team) return true;

      // If the user is currently selected
      if (user.id === props.input.value) return true;

      return false;
    })
    .map(user => _.assign({ fullName: Person.fullName(user) }, user))
    .value();

  return (
    <SelectInput
      {...props}
      isLoading={!users}
      options={options}
      valueKey="id"
      labelKey="fullName"
    />
  );
}

UserSelect.propTypes = {
  users: PropTypes.array,
  input: PropTypes.object,
  team: PropTypes.number
};

export default connect((state) => ({ users: state.pageData.selectUsers }))(UserSelect);
